import { Table } from 'reactstrap';
import { ISearchIndividualResult } from '../../../types/individual';
import PaginationBar from '../../common/pagination-bar';
import { useEffect, useState } from 'react';
import OmsToolTip from "../../common/oms-tooltip/oms-tooltip";
import TableHeaders, { TableHeaderInfo } from '../../common/table-header';
import { FaRegCircleXmark } from 'react-icons/fa6';
import useAuth from '../../../hook/useAuth';
import Button from '../../common/button';

interface SearchIndividualResultProp {
    data: ISearchIndividualResult[]|undefined,
    pageSize?:number,
    onTitleSelect: (item:ISearchIndividualResult) => void,
    onIndividualNameSelect:(item:ISearchIndividualResult) => void,
    inputChanged: boolean,
    selected?: any // the values we are expecting are strings, but this comes from the context, so it can be anything
    isInputError: boolean;
}

const TABLE_HEADERS: TableHeaderInfo<ISearchIndividualResult>[] = [
    { header: "Individual Name", accessor: "fullName", sortable: true },
    { header: "Position/Role", accessor: "positionRole", sortable: true, cssClass: "position-column" },
    { header: "Title", accessor: "title", sortable: true },
    { header: "Individual Email", accessor: "email", sortable: true },
];

function SearchIndividualResult (props:SearchIndividualResultProp) {
    const { data:records, pageSize=10, onTitleSelect, onIndividualNameSelect, inputChanged, selected,isInputError } = props;

    const [sortedData, setSortedData] = useState<ISearchIndividualResult[]>([]);
    const [pagedData, setPagedData] = useState<ISearchIndividualResult[]>([]);
    const { isAdmin  } = useAuth();

    //useEffect(() => onSelect(undefined), [pagedData]);
    return (
        <>
            <Table id="individuals_table" striped className="fixed">
                <caption className="sr-only">Search results, sortable</caption>
                <TableHeaders headers={TABLE_HEADERS} sortableData={records} onSort={setSortedData} />

                <tbody>
                    {sortedData.length>0
                        ? pagedData.map((record, index) => {
                            return <tr key={record.positionId+'-'+index}>
                                <td>
                                    <Button color="link"
                                        className={`oms-button-link ${selected === searchIndividualSelectedIndividual(record) ? 'oms-button-link-selected' : '' }`}
                                        id={`${record.positionId}-${index}-fullname`}
                                        onClick={()=>{onIndividualNameSelect(record)}}>
                                        {record.fullName}
                                    </Button>
                                </td>
                                <td>{record.positionRole}</td>
                                <td>
                                    {record.title && <Button color="link"
                                        className={`oms-button-link ${selected === searchIndividualSelectedTitle(record) ? 'oms-button-link-selected' : '' }`}
                                        id={`${record.individualId}-${index}-title`}
                                        onClick={()=>{onTitleSelect(record)}}>
                                            <OmsToolTip positionId={record.positionId}>
                                                    {record.title}
                                            </OmsToolTip>

                                    </Button>}
                                    <span> {isAdmin && (!record.active && <FaRegCircleXmark/>)}</span>
                                </td>
                                <td>{record.email}</td>
                            </tr>
                        })
                        :<tr><td colSpan={TABLE_HEADERS.length} className="text-center">{inputChanged?(isInputError ? 'No results found.' : 'Search results will appear in the table.'):'No Individuals were found with the exact search match.'}</td></tr>

                    }

                </tbody>
            </Table>

            <PaginationBar data={sortedData} pageSize={pageSize} onPageChange={setPagedData} />
        </>
    )
}

export function searchIndividualSelectedIndividual(record: ISearchIndividualResult) : string {
    return `search-individual-selected-individual-${record.individualId}-${record.positionId ?? 0}`;
}

export function searchIndividualSelectedTitle(record: ISearchIndividualResult) : string {
    // positionId should never be null in this case, but better to be safe
    return `search-individual-selected-title-${record.individualId}-${record.positionId ?? 0}`;
}

export default SearchIndividualResult
